import React,{ useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';


import ClearIcon from '@material-ui/icons/Clear';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

// import { ProgressBar, Button } from 'react-bootstrap';
// import { createChart } from 'lightweight-charts';
import logoimg from '../../../images/fantomicon.png'
 import './model.css';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

  
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
      },
    modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(0, 0, 0),
        width: '100%',
        maxWidth: 750,
        border: 0,
        outline: 0,
        borderRadius: 5,
        boxShadow: '1px 1px 12px #3c3c3c'
    },
}));

// const chart = createChart(document.body, {
//         width: 400,
//         height: 300 ,
//         localization: {
//             dateFormat: 'yyyy/MM/dd',
//             priceFormatter: price =>
//                 '$' + price,
//         },
//     });
    // chart.applyOptions({
    //     timeScale: {
    //         rightOffset: 12,
    //         barSpacing: 3,
    //         fixLeftEdge: true,
    //         lockVisibleTimeRangeOnResize: true,
    //         rightBarStaysOnScroll: true,
    //         borderVisible: false,
    //         borderColor: '#fff000',
    //         visible: true,
    //         timeVisible: true,
    //         secondsVisible: false,
    //         tickMarkFormatter: (time, tickMarkType, locale) => {
    //             console.log(time, tickMarkType, locale);
    //             const year = chart.isBusinessDay(time) ? time.year : new Date(time * 1000).getUTCFullYear();
    //             return String(year);
    //         },
    //     },
    // });
// const lineSeries = chart.addAreaSeries();
// lineSeries.setData([
//     { time: '2018-10-19', value: 35.98 },
// 	{ time: '2018-10-22', value: 35.75 },
// 	{ time: '2018-10-23', value: 35.65 },
// 	{ time: '2018-10-24', value: 34.12 },
// 	{ time: '2018-10-25', value: 35.84 },
// 	{ time: '2018-10-26', value: 35.24 },
// 	{ time: '2018-10-29', value: 35.99 },
// 	{ time: '2018-10-30', value: 37.71 },
// 	{ time: '2018-10-31', value: 38.14 },
// 	{ time: '2018-11-01', value: 37.95 },
// 	{ time: '2018-11-02', value: 37.66 },
// 	{ time: '2018-11-05', value: 38.02 },
// 	{ time: '2018-11-06', value: 37.73 },
// 	{ time: '2018-11-07', value: 38.30 },
// 	{ time: '2018-11-08', value: 38.30 },
// 	{ time: '2018-11-09', value: 38.34 },
// 	{ time: '2018-11-12', value: 38.00 },
// 	{ time: '2018-11-13', value: 37.72 },
// 	{ time: '2018-11-14', value: 38.29 },
// 	{ time: '2018-11-15', value: 38.49 },
// 	{ time: '2018-11-16', value: 38.59 },
// 	{ time: '2018-11-19', value: 38.18 },
// 	{ time: '2018-11-20', value: 36.76 },
// 	{ time: '2018-11-21', value: 37.51 },
// 	{ time: '2018-11-23', value: 37.39 },
// 	{ time: '2018-11-26', value: 37.77 },
// 	{ time: '2018-11-27', value: 38.36 },
// 	{ time: '2018-11-28', value: 39.06 },
// 	{ time: '2018-11-29', value: 39.42 },
// 	{ time: '2018-11-30', value: 39.01 },
// 	{ time: '2018-12-03', value: 39.15 },
// 	{ time: '2018-12-04', value: 37.69 },
// 	{ time: '2018-12-06', value: 37.88 },
// 	{ time: '2018-12-07', value: 37.41 },
// 	{ time: '2018-12-10', value: 37.35 },
// 	{ time: '2018-12-11', value: 36.84 },
// 	{ time: '2018-12-12', value: 36.98 },
// 	{ time: '2018-12-13', value: 36.76 },
// 	{ time: '2018-12-14', value: 36.34 },
// 	{ time: '2018-12-17', value: 36.21 },
// 	{ time: '2018-12-18', value: 35.65 },
// 	{ time: '2018-12-19', value: 35.19 },
// 	{ time: '2018-12-20', value: 34.62 },
// 	{ time: '2018-12-21', value: 33.75 },
// 	{ time: '2018-12-24', value: 33.07 },
// 	{ time: '2018-12-26', value: 34.14 },
// 	{ time: '2018-12-27', value: 34.47 },
// 	{ time: '2018-12-28', value: 34.35 },
// 	{ time: '2018-12-31', value: 34.05 },
// 	{ time: '2019-01-02', value: 34.37 },
// 	{ time: '2019-01-03', value: 34.64 },
// 	{ time: '2019-01-04', value: 35.81 },
// 	{ time: '2019-01-07', value: 35.43 },
// 	{ time: '2019-01-08', value: 35.72 },
// 	{ time: '2019-01-09', value: 36.06 },
// 	{ time: '2019-01-10', value: 35.82 },
// 	{ time: '2019-01-11', value: 35.63 },
// 	{ time: '2019-01-14', value: 35.77 },
// 	{ time: '2019-01-15', value: 35.83 },
// 	{ time: '2019-01-16', value: 35.90 },
// 	{ time: '2019-01-17', value: 35.91 },
// 	{ time: '2019-01-18', value: 36.21 },
// 	{ time: '2019-01-22', value: 34.97 },
// 	{ time: '2019-01-23', value: 36.89 },
// 	{ time: '2019-01-24', value: 36.24 },
// 	{ time: '2019-01-25', value: 35.78 },
// 	{ time: '2019-01-28', value: 35.37 },
// 	{ time: '2019-01-29', value: 36.08 },
// 	{ time: '2019-01-30', value: 35.43 },
// 	{ time: '2019-01-31', value: 36.57 },
// 	{ time: '2019-02-01', value: 36.79 },
// 	{ time: '2019-02-04', value: 36.77 },
// 	{ time: '2019-02-05', value: 37.15 },
// 	{ time: '2019-02-06', value: 37.17 },
// 	{ time: '2019-02-07', value: 37.68 },
// 	{ time: '2019-02-08', value: 37.60 },
// 	{ time: '2019-02-11', value: 37.00 },
// 	{ time: '2019-02-12', value: 37.24 },
// 	{ time: '2019-02-13', value: 37.03 },
// 	{ time: '2019-02-14', value: 37.26 },
// 	{ time: '2019-02-15', value: 37.77 },
// 	{ time: '2019-02-19', value: 37.55 },
// 	{ time: '2019-02-20', value: 37.79 },
// 	{ time: '2019-02-21', value: 38.47 },
// 	{ time: '2019-02-22', value: 38.61 },
// 	{ time: '2019-02-25', value: 38.57 },
// 	{ time: '2019-02-26', value: 38.80 },
// 	{ time: '2019-02-27', value: 38.53 },
// 	{ time: '2019-02-28', value: 38.67 },
// 	{ time: '2019-03-01', value: 39.10 },
// 	{ time: '2019-03-04', value: 38.73 },
// 	{ time: '2019-03-05', value: 38.72 },
// 	{ time: '2019-03-06', value: 38.61 },
// 	{ time: '2019-03-07', value: 38.38 },
// 	{ time: '2019-03-08', value: 38.19 },
// 	{ time: '2019-03-11', value: 39.17 },
// 	{ time: '2019-03-12', value: 39.49 },
// 	{ time: '2019-03-13', value: 39.56 },
// 	{ time: '2019-03-14', value: 39.87 },
// 	{ time: '2019-03-15', value: 40.47 },
// 	{ time: '2019-03-18', value: 39.92 },
// 	{ time: '2019-03-19', value: 39.78 },
// 	{ time: '2019-03-20', value: 39.47 },
// 	{ time: '2019-03-21', value: 40.05 },
// 	{ time: '2019-03-22', value: 39.46 },
// 	{ time: '2019-03-25', value: 39.18 },
// 	{ time: '2019-03-26', value: 39.63 },
// 	{ time: '2019-03-27', value: 40.21 },
// 	{ time: '2019-03-28', value: 40.42 },
// 	{ time: '2019-03-29', value: 39.98 },
// 	{ time: '2019-04-01', value: 40.31 },
// 	{ time: '2019-04-02', value: 40.02 },
// 	{ time: '2019-04-03', value: 40.27 },
// 	{ time: '2019-04-04', value: 40.41 },
// 	{ time: '2019-04-05', value: 40.42 },
// 	{ time: '2019-04-08', value: 40.71 },
// 	{ time: '2019-04-09', value: 41.04 },
// 	{ time: '2019-04-10', value: 41.08 },
// 	{ time: '2019-04-11', value: 41.04 },
// 	{ time: '2019-04-12', value: 41.30 },
// 	{ time: '2019-04-15', value: 41.78 },
// 	{ time: '2019-04-16', value: 41.97 },
// 	{ time: '2019-04-17', value: 42.57 },
// 	{ time: '2019-04-18', value: 42.43 },
// 	{ time: '2019-04-22', value: 42.00 },
// 	{ time: '2019-04-23', value: 41.99 },
// 	{ time: '2019-04-24', value: 41.85 },
// 	{ time: '2019-04-25', value: 42.93 },
// 	{ time: '2019-04-26', value: 43.08 },
// 	{ time: '2019-04-29', value: 43.45 },
// 	{ time: '2019-04-30', value: 43.53 },
// 	{ time: '2019-05-01', value: 43.42 },
// 	{ time: '2019-05-02', value: 42.65 },
// 	{ time: '2019-05-03', value: 43.29 },
// 	{ time: '2019-05-06', value: 43.30 },
// 	{ time: '2019-05-07', value: 42.76 },
// 	{ time: '2019-05-08', value: 42.55 },
// 	{ time: '2019-05-09', value: 42.92 },
// 	{ time: '2019-05-10', value: 43.15 },
// 	{ time: '2019-05-13', value: 42.28 },
// 	{ time: '2019-05-14', value: 42.91 },
// 	{ time: '2019-05-15', value: 42.49 },
// 	{ time: '2019-05-16', value: 43.19 },
// 	{ time: '2019-05-17', value: 43.54 },
// 	{ time: '2019-05-20', value: 42.78 },
// 	{ time: '2019-05-21', value: 43.29 },
// 	{ time: '2019-05-22', value: 43.30 },
// 	{ time: '2019-05-23', value: 42.73 },
// 	{ time: '2019-05-24', value: 42.67 },
// 	{ time: '2019-05-28', value: 42.75 },
// ]);
export default function TransitionsModal(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const inputEl = useRef(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const percentage = 100;
  const percentage1 = 34;
  const percentage2 = 11;

//   useEffect(() => {
//     const script = document.createElement('script');
//         script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js'
//         script.async = true;
//         script.innerHTML = /* JSON-ENCODED SETTINGS STRING FROM EMBED CODE */
//         inputEl.current.appendChild(script);
//     }, []);
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={() => props.handleClose()}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
            <div className={classes.paper}>
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    xs={12}
                    className="pcc---buyCard px-4 pt-4"
                >
                    <Grid
                        direction="column"
                        justify="flex-start"
                        xs={12}
                        sm={6}
                        className="pcc---buyCard"
                    >
                        <h2 className="mb-0" style={{textAlign:'left',padding:'0px',border:'none',fontSize: '30px',display: "block"}}>
                            <img src={logoimg} style={{height:"100%",width:'auto',maxHeight:50,marginRight: 5}}/><strong>BUSD</strong>
                        </h2>
                    </Grid>
                    <Grid
                        container
                        direction="column"
                        justify="flex-start"
                        xs={12}
                        sm={6}
                        className="pcc---buyCard"
                    >
                        <div className="text-right pt-2">
                            <button className="pcc---model_close_btn" onClick={() => props.handleClose()}><ClearIcon /></button>
                        </div>
                    </Grid>       
                </Grid>
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    xs={12}
                    className="pcc---buyCard px-0"
                >
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        xs={12}
                        className="pcc---buyCard pcc---chart_tabs mt-3 position-relative"
                    >
                        <p className="pcc---tradebuton mr-4">Trade <a hreft="#" target="_blank"><OpenInNewOutlinedIcon /></a></p>  
                        <AppBar position="static" className="px-4">
                            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                            <Tab label="Chart" {...a11yProps(0)} />
                            <Tab label="Info" {...a11yProps(1)} />
                            <Tab label="Tokonomics" {...a11yProps(2)} />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0} className="pcc---modeltabsBody px-4 pb-4 mb-2">
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            xs={12}
                            className="pcc---buyCard"
                        >
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                xs={12}
                                sm={4}
                                className="pcc---buyCard mt-3 pr-md-1"
                            
                            >
                                <h3 style={{textAlign:'left',color:'#000',fontSize:20, marginBottom:0}}>{percentage}%</h3>
                                <p>Fully diluted mcap</p>
                            </Grid>
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                xs={12}
                                sm={4}
                                className="pcc---buyCard mt-3 px-md-1"
                            >
                                <h3 style={{textAlign:'center',color:'#000',fontSize:20, marginBottom:0}}>{percentage1}%</h3>
                                <p className="text-center">Volume 24hr </p>
                            </Grid>
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                xs={12}
                                sm={4}
                                className="pcc---buyCard mt-3 pl-md-1"
                            >
                                <h3 style={{textAlign:'right',color:'#000',fontSize:20, marginBottom:0}}>{percentage2}%</h3>
                                <p className="text-right">Price</p>
                            </Grid>
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                xs={12}
                                sm={4}
                                className="pcc---buyCard mt-3 pl-md-1"
                            >
                                <div class="tradingview-widget-container" ref={inputEl}>
                                    <div class="tradingview-widget-container__widget"></div>
                                
                                </div>
                            </Grid>
                            {/* add chart here */}
                            <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                xs={12}
                                className="pcc---buyCard px-md-3"
                                >
                                <Grid
                                    container
                                    direction="column"
                                    justify="flex-start"
                                    xs={12}
                                    sm={4}
                                    className="pcc---buyCard mt-3 pr-md-1"
                                
                                >
                                    <h6 className="text-center" style={{color:'#cdcdcd',fontSize:14}}>30d:<span style={{color:'#28a745'}}><strong>{percentage}%</strong></span></h6>
                                    {/* <ProgressBar variant="success" now={percentage}/> */}
                                </Grid>
                                <Grid
                                    container
                                    direction="column"
                                    justify="flex-start"
                                    xs={12}
                                    sm={4}
                                    className="pcc---buyCard mt-3 px-md-1"
                                >
                                    <h6 className="text-center" style={{color:'#cdcdcd',fontSize:14}}>7d:<span style={{color:'#dc3545'}}><strong>{percentage1}%</strong></span></h6>
                                    {/* <ProgressBar variant="danger" now={percentage1}/> */}
                                </Grid>
                                <Grid
                                    container
                                    direction="column"
                                    justify="flex-start"
                                    xs={12}
                                    sm={4}
                                    className="pcc---buyCard mt-3 pl-md-1"
                                >
                                    <h6 className="text-center" style={{color:'#cdcdcd',fontSize:14}}>1d:<span style={{color:'#dc3545'}}><strong>{percentage2}%</strong></span></h6>
                                    {/* <ProgressBar variant="danger" now={percentage2}/> */}
                                </Grid>
                            </Grid>
                        </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={1} className="pcc---modeltabsBody px-4 pb-4 mb-2">
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignContent="center"
                                xs={12}
                                className="pcc---buyCard mt-3 pl-md-1"
                            >
                                <button className="pcc---infoButton mx-auto">
                                    <img src={logoimg} className="mr-2" />
                                    View Token Page
                                </button>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignContent="center"
                                xs={12}
                                className="pcc---buyCard mt-4"
                            >
                                <a href="#" className="pcc---infoLInks">
                                    0x877.....ce86 <FileCopyOutlinedIcon />
                                </a>
                                <a href="#" className="px-5 pcc---infoLInks">
                                    BscScan <OpenInNewOutlinedIcon />
                                </a>
                                <a href="#" className="pcc---infoLInks">
                                    Pancakeswap V2 <OpenInNewOutlinedIcon />
                                </a>
                            </Grid>
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignContent="center"
                                xs={12}
                                className="pcc---buyCard mt-3 pt-2 text-center"
                            >
                                <p className="mb-2 pcc---infop">Total Supply: 4,201,000,000 </p>
                                <p className="mb-2 pcc---infop">Decimals 18 </p>
                                <p className="mb-2 pcc---infop">Most liquid pair</p>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={2} className="pcc---modeltabsBody">
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignContent="center"
                            >   
                                <Grid
                                    container
                                    direction="column"
                                    justify="flex-start"
                                    alignContent="flex-start"
                                    xs={6}
                                    className="pcc---buyCard mt-3 pt-2 text-left pl-4"
                                >
                                    <p className="mb-2 pcc---infop">Total Supply</p>
                                </Grid>
                                <Grid
                                    container
                                    direction="column"
                                    justify="flex-end"
                                    alignContent="flex-end"
                                    xs={6}
                                    className="pcc---buyCard mt-3 pt-2 text-right pr-4"
                                >
                                    <p className="mb-2 pcc---infop">4,201,000,000</p>
                                </Grid>
                                <Grid
                                    container
                                    direction="column"
                                    justify="flex-start"
                                    alignContent="flex-start"
                                    xs={6}
                                    className="pcc---buyCard text-left pl-4"
                                >
                                    <h5 className="m-0">Tokens locked</h5>
                                </Grid>
                                <Grid
                                    container
                                    direction="column"
                                    justify="flex-end"
                                    alignContent="flex-end"
                                    xs={6}
                                    className="pcc---buyCard text-right pr-4"
                                >
                                    <h5 className="m-0">0</h5>
                                </Grid>
                                <Grid
                                    container
                                    direction="column"
                                    justify="center"
                                    alignContent="center"
                                    xs={12}
                                    className="pcc---buyCard text-center px-4"
                                >
                                    <span className="pcc---tokonomics-locker"><LockOutlinedIcon /></span>
                                    <h5 className="m-0">0%</h5>
                                    <p className="mb-4 pcc---infop">locked of total supply</p>
                                </Grid>
                                <Grid
                                    container
                                    direction="column"
                                    justify="center"
                                    alignContent="center"
                                    xs={12}
                                    className="pcc---buyCard text-center py-3"
                                    style={{backgroundColor: "#fdb134",borderRadius:"0px 0px 5px 5px"}}
                                >
                                    <h5 className="m-0 text-light">No locks for this token</h5>
                                </Grid>
                            </Grid>
                        </TabPanel>
                    </Grid>
                </Grid>
            </div>
        </Fade>
      </Modal>
    </div>
  );
}

 